import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import ClientListTable from '@/components/ClientListTable.vue';
import ProxyListTable from '@/components/ProxyListTable.vue';
import BaseInfoItem from './BaseInfoItem.vue';

var BaseInfo = /*#__PURE__*/function (_Vue) {
  _inherits(BaseInfo, _Vue);

  var _super = _createSuper(BaseInfo);

  function BaseInfo() {
    _classCallCheck(this, BaseInfo);

    return _super.apply(this, arguments);
  }

  return BaseInfo;
}(Vue);

__decorate([Prop({
  required: true
})], BaseInfo.prototype, "id", void 0);

__decorate([Prop({
  required: true
})], BaseInfo.prototype, "data", void 0);

BaseInfo = __decorate([Component({
  components: {
    BaseInfoItem: BaseInfoItem,
    ClientListTable: ClientListTable,
    ProxyListTable: ProxyListTable
  }
})], BaseInfo);
export default BaseInfo;